import { FC } from "react";
import { Box, Text } from "@chakra-ui/react";
import { Heading } from "@chakra-ui/react";
import { HeadButton } from "../../../customComponents/components/HeadButton";

export const CardsBlock: FC<{
  title: string;
  children: React.ReactNode;
  isSubmitting?: boolean;
  onClick?: () => void;
  user_id?: string | number;
  isUnique?: boolean;
}> = ({ title, children, isSubmitting, onClick, user_id, isUnique }) => (
  <Box background="#FAFAFA" border="1px solid #E0E3E7" h="auto">
    <Box
      sx={{
        padding: "15px 30px",
        background: "#E0E3E7",
        borderBottom: "1px solid #E0E3E7",
      }}
    >
      <Heading size="sm">{title}</Heading>
    </Box>
    <Box padding="30px">{children}</Box>
    {isSubmitting && (
      <Box margin="30px ">
        <HeadButton onClick={onClick}>Сохранить</HeadButton>
      </Box>
    )}
    {isUnique && (
      <Box padding="0 30px 20px">
        <Text fontSize="sm" color="#A6A8AE">
          уникальный ID пользователя: {user_id}
        </Text>
      </Box>
    )}
  </Box>
);
